var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.assetValue),expression:"assetValue"}],staticClass:"mx-2 my-3 text-center"},[_c('p',{staticClass:"font-bold uppercase text-xs text-gray-500"},[_vm._v(_vm._s(_vm.assetPropety))]),_c('p',[_vm._v(" "+_vm._s(_vm.assetValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }